'use client';

import { useTranslations } from 'next-intl';
import styles from './error.module.css';
import { Button } from '@/components/ui/button';
import { useBoundaryErrorReport } from '@/lib/observability/report-boundary-error';

interface Props {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function RecipesError({ error, reset }: Props) {
  const tc = useTranslations('common');
  const t = useTranslations('recipes');

  useBoundaryErrorReport('recipes', error);

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.heading}>{tc('error')}</h1>
      <p className={styles.message}>{t('errorMessage')}</p>
      <Button onClick={reset}>{tc('retry')}</Button>
    </div>
  );
}
